interface UmamiAnalyticsProps {
  blockedPathPrefixes: string[];
  enabled: boolean;
  nonce: string;
  scriptUrl: string;
  trackedDomain: string;
  websiteId: string;
}

const beforeSendFunctionName = "filterUmamiEvent";

// Load the production tracker with conservative collection defaults and omit
// events from routes whose paths can contain credentials or private IDs.
//
export function UmamiAnalytics({
  blockedPathPrefixes,
  enabled,
  nonce,
  scriptUrl,
  trackedDomain,
  websiteId,
}: UmamiAnalyticsProps) {
  if (!enabled) return null;

  const beforeSendScript = buildBeforeSendScript(blockedPathPrefixes);

  return (
    <>
      {beforeSendScript ? (
        <script
          dangerouslySetInnerHTML={{ __html: beforeSendScript }}
          nonce={nonce}
        />
      ) : null}
      <script
        defer
        data-before-send={beforeSendScript ? beforeSendFunctionName : undefined}
        data-do-not-track="true"
        data-domains={trackedDomain}
        data-exclude-hash="true"
        data-exclude-search="true"
        data-performance="true"
        data-website-id={websiteId}
        nonce={nonce}
        src={scriptUrl}
      />
    </>
  );
}

// Define Umami's pre-send hook before the deferred tracker runs. The prefixes
// are hard-coded server configuration rather than request-controlled values.
//
function buildBeforeSendScript(blockedPathPrefixes: string[]) {
  if (blockedPathPrefixes.length === 0) return "";

  return `window.${beforeSendFunctionName} = function (_type, payload) {
    const path = window.location.pathname;
    const blockedPathPrefixes = ${JSON.stringify(blockedPathPrefixes)};
    return blockedPathPrefixes.some((prefix) => path.startsWith(prefix))
      ? false
      : payload;
  };`;
}
